import styled from 'styled-components'
import { Button } from 'antd'

export const Wrapper = styled.div`
  padding: 24px;
`

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const StyledButton = styled(Button)`
  &:not(:first-child) {
    margin-top: 10px;
  }
`